import type { ReactNode } from "react";
import { Modal } from "@/react/components/shared/uikit/ModalV2";
import { Tabs } from "@/react/components/shared/uikit/Tabs";
import { useIsPaywallsModalsV3 } from "@/react/hooks/useIsPaywallsModalsV3";
import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { NavItem } from "../../../components/NavItem";
import { usePaywallFormContext } from "../../PaywallFormProvider";
import { LeftContainer } from "./LeftContainer";

interface HeaderProps {
  activeTab: string;
  onClickTab: (tab: string) => void;
  rightContainer?: ReactNode;
  tabs: { label: string; disabled?: boolean }[];
}

export const Header = ({
  tabs,
  activeTab,
  onClickTab,
  rightContainer,
}: HeaderProps) => {
  const isPaywallsModalsV3 = useIsPaywallsModalsV3();
  const { onClose } = usePaywallFormContext();

  if (!isPaywallsModalsV3) {
    return (
      <>
        <Modal.Header className="flex flex-row justify-between !pt-4">
          <LeftContainer />
          <Modal.HeaderActions>
            <Modal.CloseButton
              onClick={onClose}
              data-testid="paywall-admin-modal-close-button"
            />
          </Modal.HeaderActions>
        </Modal.Header>
        <div className="border-primary border-b">
          <Tabs
            className="px-8"
            wrapperClassName="border-0"
            controlled
            activeTab={activeTab}
            onClick={onClickTab}
            options={tabs}
            variant="underline"
          />
        </div>
      </>
    );
  }

  return (
    <FullScreenModal.HeaderNav.NavContainer className="!grid-cols-[1fr_3fr_1fr] md:px-4 md:py-[1.125rem]">
      <FullScreenModal.HeaderNav.LeftContainer>
        <LeftContainer />
      </FullScreenModal.HeaderNav.LeftContainer>

      <FullScreenModal.HeaderNav.NavGroup>
        {tabs.map(tab => (
          <NavItem
            {...tab}
            active={tab.label === activeTab}
            key={tab.label}
            onClick={() => onClickTab(tab.label)}
          />
        ))}
      </FullScreenModal.HeaderNav.NavGroup>

      {rightContainer && (
        <FullScreenModal.HeaderNav.RightContainer className="hidden lg:flex">
          {rightContainer}
        </FullScreenModal.HeaderNav.RightContainer>
      )}
    </FullScreenModal.HeaderNav.NavContainer>
  );
};
